<button class="btn btn-default" (click)="applyFilters()">Filter<i class="fa fa-filter" style="padding-left: 5px;"></i></button>

